// extracted by mini-css-extract-plugin
export default {"Background":"Background_Background__3Vd8f","secondLayerBG":"Background_secondLayerBG__VJ4bk","appear":"Background_appear__JTaKp"};